import { render, staticRenderFns } from "./UIRadioButton.vue?vue&type=template&id=849783a0&"
import script from "./UIRadioButton.vue?vue&type=script&lang=js&"
export * from "./UIRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./UIRadioButton.vue?vue&type=style&index=0&id=849783a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports